exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text_class_legend_map{font-size:.8em}", ""]);

// exports
